export default __webpack_public_path__ + "static/media/Vector.df49ff9e.svg";